@if (form) {
  <form [formGroup]="form">
    @if (!loading) {
      <mat-tab-group>
        <mat-tab label="Receipt" i18n-label="@@WawiAPI_CreateOrder_TabBeleg">
          <div class="row">
            <div class="col-5">
              <frm-wawi-belart-select i18n-label="@@WawiAPI_CreateOrder_BelegartLabel" label="Receipt Type"
                formControlName="belegart"
              [include]="[WawiBelegArt.Angebot, WawiBelegArt.Auftrag]"></frm-wawi-belart-select>
            </div>
            <div class="col-7">
              <frm-wawi-prodlin-select i18n-label="@@WawiAPI_CreateOrder_ProduktlinieLabel" label="Product Line"
              formControlName="produktlinie" resultMode="name"></frm-wawi-prodlin-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-wawi-address-select i18n-label="@@WawiAPI_CreateOrder_AdresseLabel" label="Kunde"
              formControlName="adressID"></frm-wawi-address-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-text i18n-label="@@WawiAPI_CreateOrder_InfoLabel" label="Receipt Info"
              formControlName="info"></frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-text i18n-label="@@WawiAPI_CreateOrder_KennwortLabel" label="Customer Code Word"
              formControlName="kennwort"></frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-date-picker i18n-label="@@WawiAPI_CreateOrder_BelegdatumLabel" label="Receipt Date"
              formControlName="belegdatum"></frm-date-picker>
            </div>
            <div class="col">
              <frm-text i18n-label="@@WawiAPI_CreateOrder_IhreBestellungLabel" label="Your Order"
              formControlName="ihreBestellung"></frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-text i18n-label="@@WawiAPI_CreateOrder_IhrZeichenLabel" label="Your Sign"
              formControlName="ihrZeichen"></frm-text>
            </div>
            <div class="col">
              <frm-text i18n-label="@@WawiAPI_CreateOrder_UnserZeichenLabel" label="Our Sign"
              formControlName="unserZeichen"></frm-text>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Facilities" i18n-label="@@WawiAPI_CreateOrder_TabAnlagen">
          <ctrl-btn icon="add" content="Insert a facility" i18n-content="@@WawiAPI_CreateOrder_BuSelectFacility"
          (click)="OnSelectAnlage()" [disabled]="loading"></ctrl-btn>
          <hr />
          <table style="width: 100%;">
            @for (value of anlageNrInternCtrl.value; track value) {
              <tr>
                <td style="width: 90%;">{{ value }}</td>
                <td style="width: 10%;">
                  <ctrl-btn icon="close" content="Remove Facility" i18n-content="@@WawiAPI_CreateOrder_BuRemoveFacility"
                  (click)="OnRemoveAnlage(value)" [disabled]="loading"></ctrl-btn>
                </td>
              </tr>
            }
          </table>
        </mat-tab>
      </mat-tab-group>
    } @else {
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
      <app-shimmer-label></app-shimmer-label>
      <app-shimmer-input></app-shimmer-input>
    }
  </form>
}

